import { ReactNode, useReducer } from 'react';
import CartReducer from './reducer';
import { CartContext, CartDispatchContext } from './index';

export function CartProvider({ children }: { children: ReactNode }) {
  const [packages, dispatch] = useReducer(CartReducer, []);
  return (
    <CartContext.Provider value={packages}>
      <CartDispatchContext.Provider value={dispatch}>{children}</CartDispatchContext.Provider>
    </CartContext.Provider>
  );
}
